import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取个人信息
   * @returns {Promise<any>}
   */
  getProfile(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.USER_PROFILE, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取国家列表
   * @returns {Promise<any>}
   */
  getCountryList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_COUNTRY_LIST, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取省份列表
   * @returns {Promise<any>}
   */
  getRegionStateList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_REGION_STATE_LIST, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  getTaxationHandleConfig(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_HANDLE_CONFIG, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
};
